import styled from 'styled-components';

export const PrescriptionDatesContainer = styled.div`
  display: flex;
`;

export const PrescriptionDates = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const PrescriptionTrackerContainer = styled.div`
  padding-top: ${props => props.theme.space.s5};
  padding-bottom: ${props => props.theme.space.s2};
`;

export const RefillRemainingCount = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
